var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowkitchen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21H3.5C3.22386 21 3 20.7761 3 20.5V3.85714C3 3.85714 4.71429 3 7.5 3C10.2857 3 12 3.85714 12 3.85714V21ZM12 21V12.4286H12.2143C12.2143 12.4286 13.7143 13.2857 16.5 13.2857C19.2857 13.2857 20.7857 12.4286 20.7857 12.4286H21V20.5C21 20.7761 20.7761 21 20.5 21H12ZM3 9.85714C3 9.85714 4.71429 9 7.5 9C10.2857 9 12 9.85714 12 9.85714M5.14286 5.57143V7.28571M5.14286 11.1429V12.8571M17.5714 13.242V10.0714C17.5714 9.78727 17.4585 9.51475 17.2576 9.31381C17.0567 9.11288 16.7842 9 16.5 9C16.2158 9 15.9433 9.11288 15.7424 9.31381C15.5415 9.51475 15.4286 9.78727 15.4286 10.0714V10.2857",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowkitchen);
export default __webpack_public_path__ + "static/media/Showkitchen.cf43f8daaa8f29646334de9728d8a5d8.svg";
export { ForwardRef as ReactComponent };